import { FC } from 'react';

import { ActionIconButtonStyled } from './CloseReopenTicketButton.style';
import { useResponsive } from 'contexts/ResponsiveContext';
import { StatusIdE } from 'declarations/enums/tickets';
import { NoopT } from 'declarations/types/common';
import { FileMinusIcon, FilePlusIcon } from 'icons';

export type CloseReopenTicketButtonPropsT = {
  ticketStatus: StatusIdE;
  isUserTicketCreator: boolean;
  handleOpenTicketReopenPopup: NoopT;
  handleOpenTicketClosePopup: NoopT;
};

const CloseReopenTicketButton: FC<CloseReopenTicketButtonPropsT> = ({
  ticketStatus,
  isUserTicketCreator,
  handleOpenTicketReopenPopup,
  handleOpenTicketClosePopup,
}) => {
  const { isMobile } = useResponsive();

  return (
    <ActionIconButtonStyled
      disabled={!isUserTicketCreator}
      variant="transparent"
      size={isMobile ? 'md' : 'sm'}
      icon={
        ticketStatus === StatusIdE.Open || ticketStatus === StatusIdE.ReOpened ? (
          <FileMinusIcon />
        ) : (
          <FilePlusIcon />
        )
      }
      onClick={
        ticketStatus === StatusIdE.Open || ticketStatus === StatusIdE.ReOpened
          ? handleOpenTicketClosePopup
          : handleOpenTicketReopenPopup
      }
      title={
        ticketStatus === StatusIdE.Open || ticketStatus === StatusIdE.ReOpened
          ? 'Close Ticket'
          : 'Reopen Ticket'
      }
    />
  );
};

export default CloseReopenTicketButton;
